import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Par pergunta e resposta — componente 12 (leitura de dado preenchido por outra pessoa).
 * Ênfase invertida: a pergunta vira rótulo de 11px, a resposta do paciente é o texto grande em Lexend 15px.
 * Resposta que exige atenção clínica sai em plum — salta por tamanho e por cor.
 */
export interface QAPairProps extends HTMLAttributes<HTMLDivElement> {
  question: ReactNode
  answer: ReactNode
  risk?: boolean
}

export function QAPair({ question, answer, risk, className, ...props }: QAPairProps) {
  return (
    <div
      data-slot="qa-pair"
      data-risk={risk || undefined}
      className={cn('border-hairline border-b py-[14px] last:border-b-0', className)}
      {...props}
    >
      <div className="font-body text-eyebrow text-label font-light tracking-[.1em] uppercase">
        {question}
      </div>
      <div
        className={cn(
          'font-display text-name mt-[7px] font-normal text-pretty',
          risk ? 'text-plum' : 'text-ink',
        )}
      >
        {answer}
      </div>
    </div>
  )
}

/** Grupo de pares com o nome do bloco ("SUA SAÚDE") em rótulo acima. */
export function QAGroup({
  title,
  children,
  className,
  ...props
}: Omit<HTMLAttributes<HTMLDivElement>, 'title'> & { title: ReactNode }) {
  return (
    <section
      data-slot="qa-group"
      className={cn('border-hairline border-t pt-4', className)}
      {...props}
    >
      <h3 className="eyebrow">{title}</h3>
      <div className="mt-2">{children}</div>
    </section>
  )
}
